import React, { FC, useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { FormField, Label, Combobox, FormHelp } from '@zillow/constellation';
import { useListUnderwritersQuery } from 'API/underwriters/UnderwritersAPI';

const useGetUnderwriters = () => {
  const { data: underwriters = [] } = useListUnderwritersQuery();

  return useMemo(
    () =>
      underwriters.map(({ id, name }) => ({
        label: name,
        value: id,
        id,
      })),
    [underwriters]
  );
};

export const UnderwritersFilter: FC = () => {
  const [field, meta, helpers] = useField<string>({ name: 'underwriterId' });
  const underwritersOptions = useGetUnderwriters();

  const onChange = useCallback(
    (nextValue: any, constellationComboboxMeta: any) => {
      helpers.setValue(constellationComboboxMeta.option.value);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Underwriter</Label>}
      control={
        <Combobox
          value={field.value}
          options={underwritersOptions}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
